// extracted by mini-css-extract-plugin
export var dropdown = "_v6-0";
export var imageWrapper = "_v6-3";
export var itemNameContainer = "_v6-1";
export var productImage = "_v6-2";
export var spinnerWrapper = "_v6-4";